import googlePreferredIcon from "@assets/icons/googlePreferredSource.png";
import { BH_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import { useGooglePreferredSource } from "@sphtech/sph-web-ui";

export type GooglePreferredSourceButtonProps = {
  className?: string;
  pageUrl: string;
};
/**
 * A React component that renders a Google Preferred Source Button on Article page
 */
export default function GooglePreferredSourceButton({
  className,
  pageUrl,
}: GooglePreferredSourceButtonProps): React.ReactElement {
  const { addPreferredSource } = useGooglePreferredSource({ lang: "ms" });
  const bhCustomGaEvent = useBHCustomEventAnalyticsCall();

  const handleOnClick = () => {
    bhCustomGaEvent(
      "preferred source on google",
      "click",
      `${removeTrailingSlash(BH_BASE_URL)}${pageUrl}`,
    );
    addPreferredSource();
  };

  return (
    <button className={className} onClick={handleOnClick}>
      <img
        src={googlePreferredIcon}
        alt="Google News Preferred Icon"
        height="39px"
        width="125px"
      />
    </button>
  );
}
